import { jsx } from "react/jsx-runtime";
import { Accordion as MuiAccordion, styled } from "@mui/material";
const Accordion = styled((props) => /* @__PURE__ */ jsx(
  MuiAccordion,
  {
    disableGutters: true,
    elevation: 0,
    square: true,
    ...props,
    slotProps: {
      ...props.slotProps,
      transition: { unmountOnExit: true }
    }
  }
))(({ theme }) => ({
  "&:before": {
    display: "none"
  },
  "&:not(:last-child)": {
    borderBottom: 0
  },
  border: `1px solid ${theme.vars.palette.divider}`
}));
export {
  Accordion
};
//# sourceMappingURL=Accordion.js.map
